<template>
  <div class="server-item" :style="{ background: bgObj[serverIndex % 4] }">
    <div class="imgContainer">
      <img :src="serverItem.CommodityPicUrl" />
    </div>
    <p class="server-title">{{ serverItem.CommodityName }}</p>
    <p class="server-describe" v-html="serverItem.CommodityDescribe"></p>
    <div
      class="server-content"
      :style="{
        borderColor: borderObj[serverIndex % 4],
        background: contentBgObj[serverIndex % 4]
      }"
    >
      <p :class="beforeObj[serverIndex % 4]">
        <span>{{ $t('PointsMall.MarketPrice') }}</span
        ><span>{{ $t('PointsMall.Points') }}</span>
      </p>
      <pre>
        <p style="display: flex;">
          <span style="display: inline-block; width: 50%" v-html="serverItem.Price"></span>
          <span style="display: inline-block; width: 50%" v-html="serverItem.Integral"></span>
        </p>
      </pre>
      <div class="submintBtnBox">
        <el-button size="mini" @click="conversion(serverItem)">{{
          $t('PointsMall.Exchange')
        }}</el-button>
        <!-- <button size="mini" style="cursor: pointer" @click="conversion(serverItem)">兑换</button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serverItem: {
      type: Object,
      default: () => { }
    },
    serverIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      bgObj: {
        0: '#FDF9ED',
        1: '#F0F4FE',
        2: '#FFF5EB',
        3: '#EBFBF9'
      },
      borderObj: {
        0: '#EDE2C1',
        1: '#E0E5F3',
        2: '#F3E5D7',
        3: '#CBE7E3'
      },
      contentBgObj: {
        0: '#FFFDF5',
        1: '#F5F8FF',
        2: '#FFFAF4',
        3: '#F5FFFE'
      },
      beforeObj: {
        0: 'first',
        1: 'second',
        2: 'thirdly',
        3: 'fourthly'
      }
    }
  },
  methods: {
    conversion(serverItem) {
      this.$emit('conversion', serverItem, 2)
    }
  }
}
</script>

<style lang="less">
.server-item {
  // width: 375px;
  background: #fdf9ed;
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  .imgContainer {
    width: 220px;
    height: 220px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .server-title {
    font-size: 16px;
    font-weight: 500;
    color: #111827;
    line-height: 22px;
    margin-bottom: 6px;
  }
  .server-describe {
    font-size: 12px;
    font-weight: 400;
    color: #4b5563;
    line-height: 17px;
    margin-bottom: 10px;
  }
  .server-content {
    border: 1px solid;
    padding-left: 16px;
    padding-top: 13px;
    flex: 1;
    & > p {
      margin-bottom: 4px;
      font-size: 12px;
      & > span {
        display: inline-block;
        width: 50%;
      }
    }
    p:nth-child(1) {
      & > span {
        padding-left: 6px;
        position: relative;
      }
      & > span::before {
        content: '';
        width: 3px;
        height: 12px;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .first {
      & > span:before {
        background: #ffe083;
      }
    }
    .second {
      & > span:before {
        background: #86a9ff;
      }
    }
    .thirdly {
      & > span:before {
        background: #ffcc98;
      }
    }
    .fourthly {
      & > span:before {
        background: #90d9d0;
      }
    }
  }
  .submintBtnBox {
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;
    // button {
    //   width: 100%;
    //   height: 30px;
    //   margin-top: 14px;
    //   background: #fff4f4;
    //   border-radius: 15px;
    //   border: 1px solid #ffe9e9;
    // }
  }
  pre {
    overflow: initial;
  }
}
</style>
